import React, { useState, useMemo, useCallback } from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import Form from "reactstrap/es/Form"
import Input from "reactstrap/es/Input"
import { getGroupedByStatus } from './groupedUtils'

export const getTooltipContent = (listItemsHasLabel, listItemsDisable, openModalFn) => {
    const grouped = getGroupedByStatus(listItemsDisable)
    return (
        <div>
            {listItemsHasLabel.length > 0 && (
                <div>
                    <span className="cursor-pointer text-primary" onClick={() => openModalFn('hasLabel')}>{listItemsHasLabel.length}</span>
                    {' Barcode đang gen label theo luồng mới ở FFM'}
                </div>
            )}
            {listItemsDisable.length > 0 && Object.keys(grouped).map(status => (
                <div key={status}>
                    <span className="cursor-pointer text-primary" onClick={() => openModalFn(status)}>{grouped[status].length}</span>
                    {` Barcode đang ở trạng thái `}<strong>{status}</strong>
                </div>
            ))}
        </div>
    )
}

export const BarcodeListModal = ({
    modalType,
    showModal,
    listItemsHasLabel,
    listItemsDisable,
    closeModalFn,
    title,
    itemLabel
}) => {
    const grouped = getGroupedByStatus(listItemsDisable)
    let modalItems, reason
    if (modalType === 'hasLabel') {
        modalItems = listItemsHasLabel
        reason = <><strong>gen label theo luồng mới ở FFM</strong></>
    } else {
        modalItems = grouped[modalType] || []
        reason = <>Đang ở trạng thái <strong>{modalType}</strong></>
    }

    const [searchTerm, setSearchTerm] = useState('')

    const filteredItems = useMemo(() => {
        if (!searchTerm.trim()) return modalItems
        const term = searchTerm.toLowerCase().trim()
        return modalItems.filter(item =>
            String(item.barcodeNumber || '').toLowerCase().includes(term)
        )
    }, [modalItems, searchTerm])

    const handleClearSearch = useCallback(() => {
        setSearchTerm('')
    }, [])

    const displayCount = filteredItems.length !== modalItems.length
        ? `${filteredItems.length} / ${modalItems.length}`
        : modalItems.length

    return (
        <Modal isOpen={showModal} toggle={closeModalFn} size="xl">
            <ModalHeader toggle={closeModalFn}>
                {title || 'Danh sách barcode đã chọn'} ({displayCount}) - {reason}
            </ModalHeader>
            <ModalBody
                style={{
                    maxHeight: '75vh',
                    overflowY: 'auto',
                }}
            >
                <div className="d-flex align-items-center mb-3">
                    <div className="position-relative flex-grow-1">
                        <Input
                            type="text"
                            placeholder="Tìm kiếm barcode..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pr-5"
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                className="position-absolute btn-clear-search"
                                onClick={handleClearSearch}
                                style={{
                                    right: '8px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    border: 'none',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    color: '#999',
                                    fontSize: '18px',
                                    lineHeight: 1,
                                    padding: '2px 6px',
                                }}
                            >
                                ×
                            </button>
                        )}
                    </div>
                </div>
                {filteredItems.length === 0 && searchTerm ? (
                    <div className="text-center text-muted py-4">
                        <i className="icon-search2 mb-2 d-block" style={{ fontSize: '24px' }} />
                        <div>Không tìm thấy barcode phù hợp</div>
                        <div className="small mt-1">Thử từ khóa khác</div>
                    </div>
                ) : (
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                            gap: '8px 16px',
                            fontVariantNumeric: 'tabular-nums',
                        }}
                    >
                        {filteredItems.map(item => (
                            <div
                                key={item._id}
                                className="px-2 py-1 border rounded text-truncate"
                                style={{
                                    backgroundColor: '#f8f9fa',
                                    fontSize: '13px',
                                }}
                                title={item.barcodeNumber}
                            >
                                #{item.barcodeNumber}
                            </div>
                        ))}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={closeModalFn}>Đóng</Button>
            </ModalFooter>
        </Modal>
    )
}